import { ChangeDetectionStrategy, Component, input } from '@angular/core';
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'label[mat-label]',
    template: `<ng-content />{{ required() ? ' *' : '' }}`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.for]': 'for()',
        class: 'qpx-label',
        '[attr.required]': 'required() ? "" : null',
    },
})
export class QpxFormFieldLabel {
    public readonly for = input.required<string>();

    public readonly required = input(false);
}

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'mat-label[qpx], dt[qpx]',
    template: `<ng-content />{{ required() ? ' *' : '' }}`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-label',
        '[attr.required]': 'required() ? "" : null',
    },
})
export class QpxLabelStylesOnly {
    public readonly required = input<boolean>(false);
}
